import React, { useEffect, useRef, useState } from 'react';
import ImageEdit from './edit';
import ThumbnailPreviews from './previews';
import { useTranslate } from '@tolgee/react';
import { relocatePublishButtons } from '../../utils/uploadMediaFile';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelImageThumbnail,
  clearImageThumbnail,
  updateEditedImagePresets,
  updateEditedImageState,
  updateEditorImagePresets,
  updateLayeredImagePresets,
  updateLayeredImageState,
  updateUploadedImagePresets
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { generateFirebaseUploadUrl } from '../../../../redux/slices/lomavisCreator/utils';
import axios from 'axios';
import toast from 'react-hot-toast';

import {
  MAIN_COLOR_CODES,
  PRIMARY_DARK,
  UPLOAD_TYPE_THUMBNAIL
} from '../../../../config/constants';
import { getImageDimensions } from '../../utils/helpers';
import axiosClient from '../../../../utils/axios';
import { AddImageButton, EditorHeader } from '../sharedComponents';
import EditorTitle from '../commonElements/editorTitle';

const EditPreview = ({
  handleClose,
  handleCloseNoConfirmation,
  successNotification,
  currentOverlay,
  selectedImage,
  inputRef,
  bgImg
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const footerRef = useRef(null);
  const fileInputRef = useRef(null);
  const [rightMargin, setRightMargin] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [startSubmission, setStartSubmission] = useState(false);
  const [triggerFullEditorImage, setTriggerFullEditorImage] = useState(false);

  const location_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.locationUuid
  );
  const cloud_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.cloudUuid
  );
  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin
    });
  }, []);

  const cancelEdits = () => {
    // dispatch(
    //   clearImageThumbnail({
    //     platform,
    //   })
    // );
    handleClose();
  };

  const handleSubmit = async () => {
    setStartSubmission(true);
  };

  useEffect(() => {}, []);

  return (
    <div
      style={{ overflowY: 'auto' }}
      className="d-flex flex-column w-100 h-100 position-relative gap-4 "
    >
      <div
        style={{ backgroundColor: startSubmission ? 'white' : '' }}
        className="w-100 h-100 d-flex gap-4 justify-content-center rounded-3"
      >
        <div
          style={{
            // width: '66%',
            width: '100%',
            display: startSubmission ? 'none' : 'flex'
          }}
        >
          <div
            style={{ overflowY: 'hidden' }}
            className="d-flex flex-column gap-3 flex-fill h-100 overflow-hidden bg-white rounded-3"
          >
            <ImageEdit
              fileInputRef={fileInputRef}
              setStartSubmission={setStartSubmission}
              handleCloseNoConfirmation={handleCloseNoConfirmation}
              handleClose={handleClose}
              triggerFullEditorImage={triggerFullEditorImage}
              currentOverlay={currentOverlay}
              inputRef={inputRef}
              selectedImage={selectedImage}
              bgImg={bgImg}
            />
          </div>
        </div>

        {/*<div*/}
        {/*  style={{ width: startSubmission ? '50%' : '33%', maxWidth: '700px' }}*/}
        {/*  className="h-100 d-flex flex-column gap-4 align-items-center "*/}
        {/*>*/}
        {/*  {startSubmission && (*/}
        {/*    <p*/}
        {/*      style={{ fontSize: '24px', fontWeight: 'bolder' }}*/}
        {/*      className="text-dark w-100 d-flex justify-content-center text-center bg-white rounded-3 p-4"*/}
        {/*    >*/}
        {/*      {t('lomavisCreator.savingThumbnail')}*/}
        {/*    </p>*/}
        {/*  )}{' '}*/}
        {/*  <ThumbnailPreviews*/}
        {/*    startSubmission={startSubmission}*/}
        {/*    currentOverlay={currentOverlay}*/}
        {/*    selectedImage={selectedImage}*/}

        {/*</div>*/}
      </div>{' '}
      {/* <div
        ref={footerRef}
        style={{ bottom: "0", zIndex: 100, height: "60px" }}
        className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white py-2 border-top rounded-3"
      >
        {!startSubmission && (
          <Button onClick={cancelEdits} variant="secondary" size="sm">
            {t("lomavisCreator.cancel")}
          </Button>
        )}
        <Button
          style={{ marginRight: rightMargin + "px" }}
          variant="primary"
          size="sm"
          onClick={() => {
            handleSubmit();
          }}
          disabled={startSubmission}
        >
          {startSubmission && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          {startSubmission
            ? t("lomavisCreator.buttons.saving")
            : t("lomavisCreator.buttons.save")}
        </Button>
      </div> */}
      {/* {startSubmission && (
        <div
          style={{
            width: "100%",
            height: "100%",
            zIndex: 120,
            top: "1px",
            left: "1px",

            backgroundColor: "white",
            opacity: 0.3,
          }}
          className="underlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
        >
          <p
            style={{ fontSize: "40px", fontWeight: "bolder" }}
            className="text-dark"
          >
            {t("lomavis_creator.saving")}
          </p>
        </div>
      )} */}
    </div>
  );
};

export default EditPreview;
